<template>
	<v-chip color="blue lighten-5" text-color="blue lighten-1" class="tracking-number" @click="clicked">
		<v-avatar color="blue lighten-3">
			<v-icon small color="white">fas fa-eye</v-icon>
		</v-avatar>
		{{number}}
	</v-chip>
</template>

<script>
export default {
	props: ["number"],
	data() {
		return {};
	},
	methods: {
		clicked() {
			this.$emit("clicked", this.number);
		},
	},
};
</script>
